import React, {Component} from 'react';
import {BreadcrumbsItem} from 'react-breadcrumbs-dynamic';
import {Routes, Route} from 'react-router-dom'
import {withTranslation} from 'react-i18next';

import { withStyleguide, withAuthentication, withRouter} from "cw-styleguide-react";
import {route} from "./routes";
import LandingController from "./routes/landing/controllers/LandingController";
import CoursesController from "./routes/courses/controllers/CoursesController";
import ProvidersController from "./routes/providers/controllers/ProvidersController";
import TranslationsController from "./routes/translations/controllers/TranslationsController";
import VenueController from "./routes/venues/controllers/VenueController";
import ContactsController from "./routes/contacts/controllers/ContactsController";
import AssetsProvider from "./components/AssetsProvider";
import AccessDeniedController from "./routes/accessDenied/controllers/AccessDeniedController";
import TranslationsLandingController from "./routes/translations/controllers/TranslationsLandingController";
import VenuesTranslateController from "./routes/venues/controllers/translate/VenuesTranslateController";
import CoursesTranslateController from "./routes/courses/controllers/translate/CoursesTranslateController";
import UnauthenticatedController from "./routes/unauthenticated/controllers/UnauthenticatedController";
import CourseGroupsController from "./routes/courseGroup/controllers/CourseGroupsController";
import NotFoundController from "./routes/notFound/controllers/NotFoundController";
class App extends Component {

  /**
   * ComponentDidMount.
   */
  componentDidMount() {
    // Setup language switcher.
    this.props.styleguide.setLanguageUrl(route('landing', null, this.props.i18n.language === 'en' ? 'cy' : 'en').substr(1));

  }

  /**
   * Render.
   * @returns {JSX.Element}
   */
  render() {

    // If the user is not logged in.
    if (!this.props.authentication.isAuthenticated ) {
      return <UnauthenticatedController/>
    }

    // Translators @todo change to use role component
    if (this.props.authentication.hasRole('Courses_Translator') || this.props.authentication.hasRole('Courses_TranslatorManager')  ) {
      return (
        <AssetsProvider>

          <BreadcrumbsItem to={route('landing')}>
            {this.props.t('view.translations.landing.breadcrumb')}
          </BreadcrumbsItem>

          <Routes>

            {/* Landing */}
            <Route path={route('landing')} exact={true}
                   element={<TranslationsLandingController {...this.props}/>}/>

            {/* Venues Translation */}
            <Route path={route('venuesTranslateManage')+ "/*"}
                   element={<VenuesTranslateController {...this.props}/>}/>

            {/* Courses Translation */}
            <Route path={route('coursesTranslateManage')+ "/*"}
                   element={<CoursesTranslateController {...this.props}/>}/>

              <Route path="*" element={<NotFoundController  {...this.props} />} />
          </Routes>
        </AssetsProvider>
      )
    }
    if (this.props.authentication.hasRole('Courses_Provider') || this.props.authentication.hasRole('Courses_CWStaff')  ) {
      return (
        <AssetsProvider>

          <BreadcrumbsItem to={route('landing')}>
            {this.props.t('view.landing.breadcrumb')}
          </BreadcrumbsItem>
          <Routes>

            {/* Landing */}
            <Route path={route('landing')} exact={true}
                   element={<LandingController {...this.props}/>}/>

            {/* Courses */}
            <Route path={route('coursesManage')+ "/*"}
                   element={<CoursesController {...this.props}/>}/>

            {/* Providers */}
            <Route path={route('providers')}
                   element={<ProvidersController {...this.props}/>}/>

            {/* Translations */}
            <Route path={route('translations')}
                   element={<TranslationsController {...this.props}/>}/>

            {/* Course Group */}
            <Route path={route('courseGroupsManage') + "/*"}
                   element={<CourseGroupsController {...this.props}/>}/>

            {/* Venues */}
            <Route path={route('venuesManage') + "/*"}
                   element={<VenueController {...this.props}/>}/>

            {/* Contacts */}
            <Route path={route('contactsManage') + "/*"}
                   element={<ContactsController {...this.props}/>}/>

            {/*/!* 404 *!/*/}
            <Route path="*" element={<NotFoundController  {...this.props} />} />


          </Routes>
        </AssetsProvider>
      )
    }

    // Default to access denied.
    return <AccessDeniedController/>
  }
}


export default withAuthentication(withRouter(withStyleguide(withTranslation('local')(App))));
